import { styled, TextField, TextFieldProps } from '@mui/material'

type StyledTextFieldProps = TextFieldProps & {
  isLongLabel?: boolean
}

export const StyledTextField = styled(({ isLongLabel, ...props }: StyledTextFieldProps) => (
  <TextField {...props} />
))(({ theme, isLongLabel }) => ({
  '& .MuiInputBase-root': {
    height: '100%',
    alignItems: 'center',
  },
  '& input': {
    height: '100%',
    paddingInline: theme.spacing(1.5),
    boxSizing: 'border-box',
    transform: 'translateY(-5px)',
  },
  [theme.breakpoints.down('md')]: {
    '& .MuiAutocomplete-input:first-child': {
      paddingTop: '20px !important',
      paddingRight: '20px !important',
    },
  },
  ...(isLongLabel && {
    [theme.breakpoints.down('xs')]: {
      '& .MuiInputLabel-shrink': {
        transform: 'translate(0, 0px) scale(0.857)',
      },
    },
  }),
}))
